import { useContext, useEffect, useState } from "react"

import { useLocalSearchParams } from "expo-router"

import { Asset, AssetCollection, Index } from "wealthmode-frontend/backend"

import { DetailField, DetailLink, ResourceDetail } from "@/components"
import { BackendContext } from "@/context"

export default function Assets() {
  const backend = useContext(BackendContext)
  const { asset_id } = useLocalSearchParams<{ asset_id: string }>()
  const [asset, setAsset] = useState<Asset>()

  useEffect(() => {
    ;(async () => {
      var data = backend.link("data").resolve() as Index
      await data.fetch({ reload: true })

      var assets = data.link("assets")?.resolve() as AssetCollection | undefined
      if (!assets) {
        return undefined
      }

      const ass = assets.model(asset_id)
      await ass.fetch({
        reload: true,
      })

      setAsset(ass)
    })()
  }, [])

  const fields: DetailField[] = []
  const links: DetailLink[] = [
    { href: `/assets/${asset_id}/history`, label: "History" },
    { href: `/assets/${asset_id}/sales_charge`, label: "Sales Charge" },
  ]

  if (asset) {
    fields.push({ label: "Symbol", value: asset.attributes.symbol }, { label: "Type", value: asset.attributes.type })
  }

  return (
    <ResourceDetail
      title={asset?.attributes.name || "Asset"}
      subtitle={asset_id}
      loading={!asset}
      fields={fields}
      links={links}
    />
  )
}
